import { ReactNode } from 'react';
import clsx from 'clsx';
import { useUserStore } from '@/stores/userStore';

export interface PageWrapperProps {
  children: ReactNode;
  className?: string;
  withPadding?: boolean;
}

export const PageWrapper = ({
  children,
  className,
  withPadding = true,
}: PageWrapperProps) => {
  const { isRegistered } = useUserStore();

  return (
    <div
      className={clsx(
        'min-h-screen bg-cream-100',
        // Add padding for header
        'pt-16',
        // Add padding for bottom nav if registered
        isRegistered && 'pb-20',
        className
      )}
    >
      <div className={clsx('container-safe', withPadding && 'py-6')}>
        {children}
      </div>
    </div>
  );
};